import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OpdComponent} from './opd.component';
import {routing} from './opd.routing';
import {LayoutModule} from '../layout/layout.module';
import {MstGenderService} from '../configuration/mst-gender/mst-gender.service';
import { FollowupListComponent } from './followup-list/followup-list.component';
import { GenerateTokenComponent } from './generate-token/generate-token.component';
import { ListofTokenGeneratedComponent } from './listof-token-generated/listof-token-generated.component';
// import { TodaysDoctorScheduleChartComponent } from './todays-doctor-schedule-chart/todays-doctor-schedule-chart.component';
// import { DoctorScheduleChartComponent } from './doctor-schedule-chart/doctor-schedule-chart.component';

@NgModule({
  imports: [
    CommonModule, routing, LayoutModule
  ],
  declarations: [OpdComponent],
  providers: [MstGenderService]
})
export class OpdModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/opd/opd.module.ts